import {Injectable} from '@angular/core';
import {HttpClient} from "@angular/common/http";
import {environment} from '../../../environments/environment.prod';
import {NmbLookup} from "../api/nmb-lookup";
import {Observable} from "rxjs";

@Injectable({
    providedIn: 'root'
})
export class NmbService {

    constructor(private http: HttpClient) {
    }

    getStatus(checkoutId: string): Observable<NmbLookup> {
        return this.http.get<NmbLookup>(`${environment.apiUrl}/api/public/payments/nmb-payment-look-up?checkoutId=${checkoutId}`);
    }
}
